module.exports = __webpack_public_path__ + "static/media/united_effect.820d1834.png";